import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { consumeZaraPreviewSearch, emitZaraPreview } from './config';

/** Applies `?zara=1` / `?zara=0` on any app URL, then strips the param. */
export function ZaraPreviewSync() {
  const location = useLocation();
  const navigate = useNavigate();

  // Apply before sibling routes read the flag, so the first paint matches the URL.
  consumeZaraPreviewSearch(location.search);

  useEffect(() => {
    const result = consumeZaraPreviewSearch(location.search);
    if (!result.changed) return;
    emitZaraPreview();
    navigate(
      { pathname: location.pathname, search: result.nextSearch, hash: location.hash },
      { replace: true }
    );
  }, [location.hash, location.pathname, location.search, navigate]);

  return null;
}
